import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import {
  ReduceToClearRequestListContent,
  ReduceToClearRequestSearchCriteria,
  ReduceToClearRequestViewResponse
} from '../../model/reduce-to-clear-request.model';

export const ReduceToClearRequestAction = createActionGroup({
  source: 'Reduce To Clear Request',
  events: {
    RequestList: props<{ criteriaObj: ReduceToClearRequestSearchCriteria }>(),
    ResponseList: props<{
      data: Pagination<ReduceToClearRequestListContent>;
    }>()
  }
});

export const ReduceToClearRequestViewAction = createActionGroup({
  source: 'Reduce To Clear Request View',
  events: {
    Request: props<{ requestNo: string }>(),
    Response: props<{ data: ReduceToClearRequestViewResponse }>(),
    ResetView: emptyProps()
  }
});
